import * as requestFromServer from './pasoTresCrud';

import { pasoTresSlice, callTypes } from './pasoTresSlice';

const { actions } = pasoTresSlice;

export const fetchPasoTresAlDos = queryParams => async dispatch => {
    dispatch(actions.starCall({ callType: callTypes.action }));
    return await requestFromServer
        .postPasoTresAlDos(queryParams)
        .then(response => {
            const pasoTresAlDosInformacion = response.data;
            dispatch(actions.pasoTresAlDosFetched({ pasoTresAlDosInformacion }));
        })
        .catch(error => {
            error.clientMessage = error.response && (error.response.data.mensaje || error.response.data);
            dispatch(actions.catchErrorPasoTresAlDos({ error, callType: callTypes.action }));
        });
};

export const fetchPasoTresAlCuatro = queryParams => async dispatch => {
    dispatch(actions.starCall({ callType: callTypes.action }));
    return await requestFromServer
        .postPasoTresAlCuatro(queryParams)
        .then(response => {
            const extrasInformacion = response.data;
            dispatch(actions.pasoTresAlCuatroFetched({ extrasInformacion }));
        })
        .catch(error => {
            error.clientMessage = error.response && (error.response.data.mensaje || error.response.data.title || error.response.data);
            dispatch(actions.catchErrorPasoTresAlCuatro({ error, callType: callTypes.action }));
        });
};

export const stateLimpiar = queryParams => dispatch => {
    dispatch(actions.stateLimpiar());
};